<template>
	<div class="ReSelectRegionDistrict">		
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Регион</span></label>
			<el-select
                class="col-md-12 select-primary"
                size="large"                
                placeholder="Выберите регион"
                filterable
                v-model="value.region"
                @change="onRegionChange"
                clearable
            >
                <el-option
                    v-for="(region, index) in regions"
                    class="select-primary"
                    :value="region.value"
                    :label="region.label"
                    :key="index"                    
                ></el-option>
            </el-select>
		</div>
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Район</span></label>
			<el-select
                class="col-md-12 select-primary"
                size="large"                
                placeholder="Выберите район"
                filterable
                v-model="value.district"
                clearable
            >
                <el-option
                    v-for="(district, index) in districts"
                    class="select-primary"
                    :value="district.id"
                    :label="district.name"
                    :key="index"                    
                ></el-option>
            </el-select>
		</div>
		
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReSelectRegionDistrict',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: Object,
			findId: {
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: false
			},
			
		},
		data () {
			return {
				ver: 1,	
				regions: [],  
				districts: [],
			}
		},
		computed: {

		},
		methods: {
			onRegionChange(saveDistrict){
				// console.log(arguments);
				let filter = {'list':true,act:1,'region':this.value.region};
				if(!saveDistrict)
					this.value.district = '';
				this.$GVO.ApiCall('cat_districts.GET',{flt:{...filter}},{useCache:true})
				.then((objApi) => {
					this.districts = [];
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.districts = objApi.data.map(d=>({
								id: d.id,
								name: d.cellName,
							}));
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));				
			},
			GetRegionList(){
				this.regions = [];
				// console.log('load region');
				this.$GVO.LoadCatPromise('CAT_REGION')
				.then((objApi) => {
					// console.log(objApi);
					if(objApi=== true){
						this.regions = [];
						for (let i = 0; i < this.$GVO.cats.CAT_REGION.length; i++) {
							const element = this.$GVO.unlinkObject(this.$GVO.cats.CAT_REGION[i]);
							this.regions.push({value: element.regioncode, label: element.name});
							if(this.value && this.value.region){
								this.onRegionChange(true,);
							}
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));				
				
			},
			// cancalReadOnly(onOff) {
            //     this.$nextTick(() => {
            //         if (!onOff) {
            //             const {select} = this.$refs;
            //             const input = select.$el.querySelector('.el-input__inner');
            //             input.removeAttribute('readonly');
            //         }
            //     });
            // }
		},
		mounted() {
			this.GetRegionList();           
		}
	}
</script>
<style scoped>
.white-content .el-input input::placeholder {color:#222a42;} 
.white-content .form-options-group  >>> .el-input__inner::placeholder {color:#222a42;} 
</style>
